// Vendor imports
const React = require('react')

function useToggleState(initialState) {
  const [ value, setValue ] = React.useState(!!initialState)
  const toggleValue = React.useCallback(
    () => setValue(bool => !bool),
    [ setValue ]
  )
  return [ value, toggleValue ]
}

module.exports = useToggleState
